<template>
  <div>
    <div class="search-bar-margin-bottom-cla">
      <el-form ref="searchForm"
               :model="params"
               inline
               label-width="80">
        <el-form-item prop="dstName"
                      :label="$t('dstConfig.dstName')">
          <el-input type="text"
                    v-model.trim="params.dstName"
                    :placeholder="this.$t('dstConfig.dstNameRequire')">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     @click="query()">{{
            $t('common.search')
          }}</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="black_panel_cla">
      <div class="header-button-bar">
        <zk-tool-bar @showAdd="showAdd"
                     @timeSnyc="timeSnyc"></zk-tool-bar>
      </div>

      <zk-table :columns="columns"
                v-loading="listLoading"
                :data="data"
                @update="showUpdate"
                @remove="deleteDstConfig">
      </zk-table>
      <div class="pagination-margin-top">
        <el-pagination background
                       @size-change="pageSizeChange(arguments[0], pageList)"
                       @current-change="curPageChange(arguments[0], pageList)"
                       :current-page="pager.curPage"
                       :page-size="pager.pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pager.total">
        </el-pagination>
      </div>
    </div>

    <el-dialog :title="state.title"
               :visible.sync="state.saveOrUpdate"
               :before-close="beforeClose"
               width="45%">
      <zk-DST-save-or-update ref="saveOrUpdate"
                             :form="row"
                             :isUpdate="state.isUpdate">
      </zk-DST-save-or-update>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="onCancel">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary"
                   @click="saveOrUpdate">{{
          $t('common.confirm')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import * as dstConfigApi from '@/services/dstConfigApi.js'
import { Loading } from 'element-ui'
export default {
  data () {
    let _self = this
    let data = []
    let params = {}

    let columns = [
      {
        prop: 'dstName',
        label: this.$t('dstConfig.dstName'),
        minWidth: '120px'
      },
      {
        prop: 'timezone',
        label: this.$t('dstConfig.timezone')
      },
      {
        prop: 'startTime',
        label: this.$t('dstConfig.startTime')
      },
      {
        prop: 'endTime',
        label: this.$t('dstConfig.endTime')
      },
      {
        prop: 'startYear',
        label: this.$t('dstConfig.startYear')
      },
      {
        prop: 'endYear',
        label: this.$t('dstConfig.endYear'),
        render: (h, params) => {
          let res =
            params.row.endYear === undefined || params.row.endYear === ''
              ? 'N/A'
              : params.row.params
          return h('span', {}, res)
        }
      },
      {
        prop: 'active',
        label: this.$t('dstConfig.active'),
        render: (h, params) => {
          return h('zk-dictionary-transform', {
            props: {
              value: params.row.active === 1 ? 1 : 0,
              type: 'status'
            }
          })
        }
      },
      {
        label: this.$t('common.operation'),
        minWidth: '120px',
        render: (h, params) => {
          return h('ZkButtonGroup', {
            props: {
              onlyShowText: true,
              groupName: 'dstBtnGroup',
              params: params.row
            },
            on: {
              showUpdate () {
                _self.row = params.row
                _self.showUpdate()
              },
              remove () {
                _self.row = params.row
                _self.deleteDstConfig()
              }
            }
          })
        }
      }
    ]
    let row = {}
    let state = {
      saveOrUpdate: false,
      title: '',
      isUpdate: false
    }
    return {
      columns,
      row,
      data,
      state,
      params,
      listLoading: true,
      loadingInstance: null
    }
  },
  mounted () {
    this.query()
  },
  methods: {
    renderHeader (h, { column }) {
      return h('div', [
        h('span', column.label),
        h(
          'el-tooltip',
          {
            props: {
              effect: 'dark',
              content: this.$t('dstConfig.colHeaderTip'),
              placement: 'bottom'
            }
          },
          [
            h('i', {
              class: 'el-icon-question',
              style: 'color:#7ac143; margin-left: 5px; cursor: pointer; '
            })
          ]
        )
      ])
    },
    showLoading () {
      this.loadingInstance = Loading.service({
        lock: true,
        fullscreen: true,
        text: this.$t('common.timeSnyc'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    closeLoading () {
      this.loadingInstance.close()
    },
    timeSnyc () {
      this.showLoading()
      dstConfigApi
        .timezoneSync()
        .then(data => {
          if (data.code === '00000000') {
            this.closeLoading()
            this.pageList()
          } else {
            this.$message.error(data.message)
          }
        })
        .catch(e => this.errorMessage())
    },
    query () {
      this.pager.curPage = 1
      this.pageList()
    },
    pageList () {
      let params = {
        pager: this.pager,
        params: this.params
      }
      dstConfigApi.pageList(params).then(data => {
        this.data = data.payload.results
        this.pager.curPage = data.payload.curPage
        this.pager.total = data.payload.totalRecords
        this.pager.pageSize = data.payload.pageSize
      })
      this.listLoading = false
    },
    showAdd () {
      this.row = {}
      this.state.isUpdate = false
      this.state.title = this.$t('dstConfig.addDstConfig')
      this.state.saveOrUpdate = true
    },
    showUpdate (row) {
      // debugger
      // this.row = row
      this.state.isUpdate = true
      this.state.title = this.$t('dstConfig.updateDstConfig')
      this.state.saveOrUpdate = true
    },
    saveOrUpdate () {
      let _self = this
      this.$refs.saveOrUpdate
        .save()
        .then(res => {
          if (res.code === '00000000') {
            this.$message({
              type: 'success',
              message: `${this.state.title} ` + this.$t('common.success')
            })
            this.data = []
            this.pageList()
            _self.state.saveOrUpdate = false
          } else {
            this.$message({
              type: 'error',
              message: res.message
            })
            _self.state.saveOrUpdate = true
          }
        })
        .catch(res => {
          if (res) {
            this.$message({
              type: 'error',
              message: res.message
            })
          }
        })
    },
    deleteDstConfig () {
      this.$confirm(
        this.$t('dstConfig.confirmDeleteTip'),
        this.$t('common.confirmDelete'),
        {
          confirmButtonText: this.$t('common.yes'),
          cancelButtonText: this.$t('common.delete'),
          type: 'warning'
        }
      )
        .then(() => {
          let params = {
            id: this.row.id
          }
          dstConfigApi.deleteDstConfig(params).then(res => {
            if (res.code === '00000000') {
              this.$message({
                type: 'success',
                message: this.$t('common.successDelete')
              })
              this.params = {}
              this.query()
            } else {
              this.$message({
                type: 'error',
                message: res.message
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('common.cancelDelete')
          })
        })
    },
    addLink () {
      let params = {
        devSn: 'sn001',
        dstId: 'dst001',
        dstTimezone: '+8:00',
        status: 1
      }
      dstConfigApi.addDevDstLink(params).then(res => {
        console.log(res)
      })
    },
    updateLink () {
      let params = {
        devSn: 'sn001',
        dstId: 'dst00100',
        dstTimezone: '+8:00',
        status: 1
      }
      dstConfigApi.updateDevDstLink(params).then(res => {
        console.log(res)
      })
    },
    deleteLink () {
      let params = {
        devSn: 'sn001'
      }
      dstConfigApi.deleteDevDstLink(params).then(res => {
        console.log(res)
      })
    },
    insertTimeZOne () {
      let params = {}
      dstConfigApi.addTimeZone(params).then(res => {
        console.log(res)
      })
    },
    beforeClose () {
      this.$refs.saveOrUpdate.resetFields()
      this.state.saveOrUpdate = false
    },
    onCancel () {
      this.state.saveOrUpdate = false
      this.row = {}
      this.$refs.saveOrUpdate.resetFields()
    }
  }
}
</script>

<style scoped>
.el-table__body-wrapper {
  max-height: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/modules/dstConfig/dstConfig.vue